/// <reference path="../typings/index.d.ts"/>

'use strict';

import "babel-polyfill";
import 'reflect-metadata';
import 'zone.js/dist/zone';

import login from "./ui/preLoginApp/login/login.js";
import demo from "./ui/preLoginApp/demo.js";
import { OauthLoginCtrl } from "./ui/preLoginApp/login/oauthLogin";
import { oauthRegister } from "./ui/preLoginApp/companyRegistration/oauthRegister.js";
import passwordForgot from "./ui/preLoginApp/password/passwordForgot.js";
import passwordReset from "./ui/preLoginApp/password/passwordReset.js";
import { commify } from "./ui/ownership/commify";
import { DotLoaderComponent } from "./ui/elements/dotLoader";
import { iconComponent } from "./ui/elements/icon";
import { NotificationsComponent } from "./ui/elements/notifications";
import invited from "./ui/preLoginApp/userRegistration/invited.js";

import { externalCreditCardDirective } from "./service_ui/billing/addCreditCardModal";
import billingCurrencyFilter from "./service_ui/billing/externalBillingCurrencyFilter.js";

import { UpgradeAdapter } from '@angular/upgrade';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ElementsModule } from './ui/elements/elementsModule';
import { PreLoginComponentsModule } from './ui/preLoginApp/componentsModule';
import { UserRegistrationComponent } from "./ui/preLoginApp/userRegistration/userRegistrationComponent";

@NgModule({
    imports: [
        BrowserModule,
        ElementsModule,
        PreLoginComponentsModule
    ]
})
class LoginModule {}

const upgradeAdapter = new UpgradeAdapter(LoginModule);

const loginHtml = <string>require('text!./ui/preLoginApp/login/login.html');
const demoHtml = <string>require('text!./ui/preLoginApp/demo.html');
const passwordForgotHtml = <string>require('text!./ui/preLoginApp/password/passwordForgot.html');
const oauthLoginHtml = <string>require('text!./ui/preLoginApp/login/oauthLogin.html');
const passwordResetHtml = <string>require('text!./ui/preLoginApp/password/passwordReset.html');
const passwordSentHtml = <string>require('text!./ui/preLoginApp/password/passwordSent.html');
const oauthRegisterHtml = <string>require('text!./ui/preLoginApp/companyRegistration/oauthRegister.html');
const invitedHtml = <string>require('text!./ui/preLoginApp/userRegistration/invited.html');

let LoginApp = ($routeProvider: ng.route.IRouteProvider, $locationProvider: ng.ILocationProvider) => {
    $locationProvider.html5Mode(true).hashPrefix('');
    $routeProvider
        .when('/go/:company/:goPage', {redirectTo: '/login/oauth'})

        .when('/login/', {controller: login, template: loginHtml})
        .when('/login/demo', {controller: demo, template: demoHtml})
        .when('/login/forgot', {controller: passwordForgot, template: passwordForgotHtml})
        .when('/login/oauth', {controller: OauthLoginCtrl, template: oauthLoginHtml})
        .when('/login/reset', {controller: passwordReset, template: passwordResetHtml})
        .when('/login/sent', {template: passwordSentHtml})
        .when('/login/:oops*', {redirectTo: '/login/'})

        .when('/register/company-onestep', {redirectTo: '/register'})
        .when('/register/people', {controller: invited, template: invitedHtml})
        .when('/register', {controller: oauthRegister, template: oauthRegisterHtml})
        .when('/register/oauth', {redirectTo: '/register'})
        .when('/register/:oops*', {redirectTo: '/register'})

        .when('/pricing', {redirectTo: '/register'})

        .otherwise({redirectTo: '/'});
};

LoginApp.$inject = ['$routeProvider', '$locationProvider'];

declare var analytics: any;

angular.module('LoginApp',
    ['ngRoute', 'angularPayments', 'ngAnimate',
    '$strap.directives', 'ui.bootstrap', 'ui.event', 'ui.select2', 'templates'], LoginApp)
    .directive('dotLoader', <angular.IDirectiveFactory>upgradeAdapter.downgradeNg2Component(DotLoaderComponent))
    .directive('notifications', <angular.IDirectiveFactory>upgradeAdapter.downgradeNg2Component(NotificationsComponent))
    .directive('userRegistration', <ng.IDirectiveFactory>upgradeAdapter.downgradeNg2Component(UserRegistrationComponent))
    .directive('commify', <ng.IDirectiveFactory><any>commify)
    .directive('icon', <ng.IDirectiveFactory>upgradeAdapter.downgradeNg2Component(iconComponent))
    .directive('creditCard', <ng.IDirectiveFactory><any>externalCreditCardDirective)
    .filter('billingCurrencyFilter', billingCurrencyFilter)
    .run(['$location', '$rootScope', ($location: ng.ILocationService, $rootScope: ng.IScope) => {
        $rootScope.$on('$routeChangeSuccess', () => {
            analytics.page();
        });
    }]);

window.onload = () => {
    upgradeAdapter.bootstrap(document.body, ['LoginApp']);
};



// WEBPACK FOOTER //
// ./_src/login.ts